module.exports = __webpack_public_path__ + "media/distress-signal.0afd7011.mp3";